import { render, staticRenderFns } from "./ContactPickers.vue?vue&type=template&id=4138b508&scoped=true"
import script from "./ContactPickers.vue?vue&type=script&lang=js"
export * from "./ContactPickers.vue?vue&type=script&lang=js"
import style0 from "./ContactPickers.vue?vue&type=style&index=0&id=4138b508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138b508",
  null
  
)

export default component.exports